import React from "react";
import './ChangePassword.css'
import { ChangePasswordState } from "../../states/ChangePasswordState";
import { TextField, Button } from "@material-ui/core";
import CheckIcon from "../../resources/wrappers/CheckIcon";
import { AuthService, ChangePasswordStatus } from "../../services/authentication/AuthService";
import { MposLoader } from "../../components/loader/MposLoader";
import { TermsAndConditionsManager } from "../../services/termsAndConditions/TermsAndConditionsManager";
import { Subscription } from 'rxjs';
import { GoogleTagManagerService } from "../../services/analitycs/GoogleTagManagerService";
import { MposWebPortalApi } from "../../services/api/MposWebPortalApi";
import { ServiceUnavailablePage } from "../service-unavailable-page/ServiceUnavailablePage";
import StateContextProvider from '../../context/StateContext';

export class ChangePassword extends React.Component<any, ChangePasswordState> {
    private changePasswordSubscription: Subscription | null = null;
    private getTCSubscription: Subscription | null = null;
    private adminDetailsSubscription: Subscription | null = null;
    constructor(props: any) {
        super(props);
        this.state = {
            newPassword: '',
            newPasswordConfirm: '',
            changePasswordError: false,
            buttonDisabled: true,
            digitChars: false,
            upperCaseChars: false,
            lowerCaseChars: false,
            numberOfChars: false,
            showLoader: false,
            showResultDialog: false,
            changePasswordResult: false,
            showTC: false,
            changePassword500Error: false
        }

        this.handleChangePassword = this.handleChangePassword.bind(this);
        this.handleNewPasswordChanges = this.handleNewPasswordChanges.bind(this);
        this.handleConfirmNewPasswordChanges = this.handleConfirmNewPasswordChanges.bind(this);
    }

    componentDidMount() {
        GoogleTagManagerService.getInstance().pushPageEvent(this.props.history.location.pathname, 'Imposta password personale', {});
        this.setState({ changePassword500Error: false });
    }

    private handleChangePassword(event: any) {
        event.preventDefault();
        console.log("[ChangePassword] Handle change password...");
        if (this.state.newPassword === this.state.newPasswordConfirm) {
            this.setState({ changePasswordError: false });
            this.setState({ showLoader: true });
            // Call API
            this.changePasswordSubscription = AuthService.getInstance().changePassword(this.state.newPassword).subscribe((result) => {
                console.log("[ChangePassword] API call! " + result)
                if (ChangePasswordStatus.CHANGE_PWD_500_STATUS !== result) {
                    this.setState({ changePassword500Error: false });
                    if (ChangePasswordStatus.CHANGE_PWD_SESSION_EXPIRED === result) {
                        console.log("[ChangePassword] Session expired!")
                        this.setState({ showLoader: false });
                        this.setState({ changePasswordResult: false });
                        this.setState({ showResultDialog: true });
                        this.setState({ showTC: false });
                        this.showResultDialog(this.props.history, ChangePasswordStatus.CHANGE_PWD_SESSION_EXPIRED);
                    } else {
                        this.getTCSubscription = TermsAndConditionsManager.getInstance().showTCAfterChangePassword().subscribe((response) => {
                            this.adminDetailsSubscription = MposWebPortalApi.getInstance().getSuperUserDetails().subscribe((details) => {
                                let account = {
                                    totals: {
                                        users: details.numberOfUsers
                                    }
                                }
                                let analyticsData = {
                                    account: account,
                                    termId: details.numberOfTerminals
                                }
                                GoogleTagManagerService.getInstance().pushGenericEvent('login', { result: 'ok', message: null, ...analyticsData });

                                this.setState({ showLoader: false });
                                this.setState({ changePasswordResult: this.getChangePasswordResult(result) });
                                this.setState({ showTC: response });
                                this.setState({ showResultDialog: true });
                                this.showResultDialog(this.props.history, result);
                                StateContextProvider.getInstance().setProp('scope', 'response.scope');
                            }, () => {
                                this.setState({ showLoader: false });
                                this.setState({ changePasswordResult: this.getChangePasswordResult(result) });
                                this.setState({ showTC: response });
                                this.setState({ showResultDialog: true });
                                this.showResultDialog(this.props.history, result);
                            });
                        }, () => {
                            this.adminDetailsSubscription = MposWebPortalApi.getInstance().getSuperUserDetails().subscribe((details) => {
                                let account = {
                                    totals: {
                                        users: details.numberOfUsers
                                    }
                                }
                                let analyticsData = {
                                    account: account,
                                    termId: details.numberOfTerminals
                                }
                                GoogleTagManagerService.getInstance().pushGenericEvent('login', { result: 'ok', message: null, ...analyticsData });

                                this.setState({ showLoader: false });
                                this.setState({ changePasswordResult: this.getChangePasswordResult(result) });
                                this.setState({ showTC: false });
                                this.setState({ showResultDialog: true });
                                this.showResultDialog(this.props.history, result);
                            }, () => {
                                this.setState({ showLoader: false });
                                this.setState({ changePasswordResult: this.getChangePasswordResult(result) });
                                this.setState({ showTC: false });
                                this.setState({ showResultDialog: true });
                                this.showResultDialog(this.props.history, result);
                            });
                        });
                    }
                } else {
                    // Set 500 ScreenView
                    this.setState({ changePassword500Error: true });
                }
            }, () => {
                console.log("[ChangePassword] ERROR!")
                this.setState({ showLoader: false });
                this.setState({ changePasswordResult: false });
                this.setState({ showResultDialog: true });
                this.setState({ showTC: false });
                this.showResultDialog(this.props.history, ChangePasswordStatus.CHANGE_PWD_ERROR);
            })
        } else {
            this.setState({ changePasswordError: true });
        }
    }

    private getChangePasswordResult(from: ChangePasswordStatus): boolean {
        if (ChangePasswordStatus.CHANGE_PWD_SUCCESS === from) {
            return true;
        } else {
            return false;
        }
    }

    private showResultDialog(history: any, result: ChangePasswordStatus) {
        let buttonText = "TORNA ALLA LOGIN";
        if (ChangePasswordStatus.CHANGE_PWD_ERROR === result) {
            buttonText = "REIMPOSTA PASSWORD";
        } else if (ChangePasswordStatus.CHANGE_PWD_SESSION_EXPIRED === result) {
            buttonText = "TORNA ALLA LOGIN";
        }

        history.push('/result', {
            isSuccess: this.state.changePasswordResult,
            title: "Hai creato la nuova password!",
            message: "",
            errorTitle: "Si è verificato un errore durante la creazione della nuova password.",
            button: buttonText, data: {
                from: 'ChangePassword',
                showTC: this.state.showTC,
                result: this.state.changePasswordResult,
                sessionExpired: (result === ChangePasswordStatus.CHANGE_PWD_SESSION_EXPIRED)
            }
        });
    }

    componentWillUnmount() {
        if (this.changePasswordSubscription !== null) {
            this.changePasswordSubscription.unsubscribe();
        }

        if (this.getTCSubscription !== null) {
            this.getTCSubscription.unsubscribe();
        }

        if (this.adminDetailsSubscription !== null) {
            this.adminDetailsSubscription.unsubscribe();
        }
    }

    private handleNewPasswordChanges(event: any) {
        this.setState({ newPassword: event.target.value }, () => {
            this.verifyNewPasswordRules(this.state.newPassword);
        });
    }

    private handleConfirmNewPasswordChanges(event: any) {
        this.setState({ changePasswordError: false });
        this.setState({ newPasswordConfirm: event.target.value });
    }

    private verifyNewPasswordRules(newPassword: string) {
        // Check password length
        if (newPassword.length >= 8 && newPassword.length <= 20) {
            this.setState({ numberOfChars: true });
        } else {
            this.setState({ numberOfChars: false });
        }
        // Check if contains lower case char
        if ((/[a-z]/.test(newPassword))) {
            this.setState({ lowerCaseChars: true });
        } else {
            this.setState({ lowerCaseChars: false });
        }
        // Check if contains upper case char
        if ((/[A-Z]/.test(newPassword))) {
            this.setState({ upperCaseChars: true });
        } else {
            this.setState({ upperCaseChars: false });
        }
        // Check if contains digits
        if (/[0-9]/.test(newPassword)) {
            this.setState({ digitChars: true });
        } else {
            this.setState({ digitChars: false });
        }
    }

    checkPassword() {
        console.log("[ChangePassword] check password!");
        if (this.state.newPasswordConfirm !== "") {
            console.log("[ChangePassword] call checkConfirmPassword");
            this.checkConfirmPassword();
        }
    }

    checkConfirmPassword() {
        console.log("[ChangePassword] check first and second passwords fields...");
        if ((this.state.numberOfChars && this.state.lowerCaseChars && this.state.upperCaseChars && this.state.digitChars)) {
            console.log("[ChangePassword] check rules OK");
            if (this.state.newPassword === this.state.newPasswordConfirm) {
                console.log("[ChangePassword] check equality OK");
                this.setState({ changePasswordError: false });
                this.setState({ buttonDisabled: false });
            } else {
                console.log("[ChangePassword] check equality KO");
                this.setState({ changePasswordError: true });
                this.setState({ buttonDisabled: true });
                GoogleTagManagerService.getInstance().pushInputErrorWithFieldEvent('password', 'Le password non coincidono. Riprova.');
            }
        } else {
            console.log("[ChangePassword] check rules KO");
            if (this.state.newPassword === this.state.newPasswordConfirm) {
                console.log("[ChangePassword] check equality OK but rules KO");
                this.setState({ buttonDisabled: true });
            } else {
                console.log("[ChangePassword] check equality KO and rules KO");
                this.setState({ changePasswordError: true });
                this.setState({ buttonDisabled: true });
                GoogleTagManagerService.getInstance().pushInputErrorWithFieldEvent('password', 'Le password non coincidono. Riprova.');
            }
        }
    }

    render() {
        return (
            this.state.changePassword500Error ? <ServiceUnavailablePage /> :
                <div id={"main-container-change-password"}>
                    <div id={"form-change-password-box-container"}>
                        <div className={"form-change-password-box-content"}>
                            <div>
                                <p id={"change-password-title"}>
                                    Scegli la password definitiva che utilizzerai anche per accedere.
                                </p>
                            </div>
                            <div className={"change-password-form-content"}>
                                <form onSubmit={this.handleChangePassword}>
                                    <div>
                                        <TextField id="newPassword" label="Inserisci la nuova password" onBlur={() => { this.checkPassword() }}
                                            type="password" onChange={this.handleNewPasswordChanges} value={this.state.newPassword} inputProps={{ maxLength: 20 }} />
                                        <div className={"change-password-rules-container"}>
                                            <p className={"change-password-text-suggestions"}>
                                                La password deve contenere da 8 a 20 caratteri e soddisfare tutti i seguenti requisiti:
                                            </p>
                                            <div className={"change-password-rules-row"}>
                                                <div className={"change-password-rules-row-icon"}>
                                                    <CheckIcon color={!this.state.numberOfChars ? "#9596AF" : "#0B8252"} width={"40px"} height={"29px"} />
                                                </div>
                                                <div className={"change-password-rules-row-text"}>
                                                    <p className={!this.state.numberOfChars ? "change-password-rules-row-text-ko" : "change-password-rules-row-text-ok"}>{"Min 8 - Max 20 caratteri".toUpperCase()}</p>
                                                </div>
                                            </div>
                                            <div className={"change-password-rules-row"}>
                                                <div className={"change-password-rules-row-icon"}>
                                                    <CheckIcon color={!this.state.lowerCaseChars ? "#9596AF" : "#0B8252"} width={"40px"} height={"29px"} />
                                                </div>
                                                <div className={"change-password-rules-row-text"}>
                                                    <p className={!this.state.lowerCaseChars ? "change-password-rules-row-text-ko" : "change-password-rules-row-text-ok"}>{"Una lettera minuscola".toUpperCase()}</p>
                                                </div>
                                            </div>
                                            <div className={"change-password-rules-row"}>
                                                <div className={"change-password-rules-row-icon"}>
                                                    <CheckIcon color={!this.state.upperCaseChars ? "#9596AF" : "#0B8252"} width={"40px"} height={"29px"} />
                                                </div>
                                                <div className={"change-password-rules-row-text"}>
                                                    <p className={!this.state.upperCaseChars ? "change-password-rules-row-text-ko" : "change-password-rules-row-text-ok"}>{"Una lettera maiuscola".toUpperCase()}</p>
                                                </div>
                                            </div>
                                            <div className={"change-password-rules-row"}>
                                                <div className={"change-password-rules-row-icon"}>
                                                    <CheckIcon color={!this.state.digitChars ? "#9596AF" : "#0B8252"} width={"40px"} height={"29px"} />
                                                </div>
                                                <div className={"change-password-rules-row-text"}>
                                                    <p className={!this.state.digitChars ? "change-password-rules-row-text-ko" : "change-password-rules-row-text-ok"}>{"Un numero".toUpperCase()}</p>
                                                </div>
                                            </div>
                                        </div>
                                        <TextField id="confirmPassword" label="Conferma la nuova password"
                                            type="password" onChange={this.handleConfirmNewPasswordChanges} value={this.state.newPasswordConfirm}
                                            error={this.state.changePasswordError} inputProps={{ maxLength: 20 }} onBlur={() => { this.checkConfirmPassword() }} />
                                        <p className={`change-password-error-label ${this.state.changePasswordError ? '' : 'change-password-error-label-hidden'}`}>Le password non coincidono. Riprova.</p>
                                    </div>
                                    <div className={"form-elements"}>
                                        <Button className={"change-password-submit-button"}
                                            type={"submit"}
                                            disabled={this.state.buttonDisabled}>CONFERMA</Button>
                                    </div>
                                    {
                                        // @ts-ignore
                                        <MposLoader show={this.state.showLoader} />
                                    }
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
        );
    }
}